import moment from 'moment'

export const formatDdMmYyyy = (date) => {
    return date.format('DD/MM/YYYY')
}

export const formatDdMmmYyyy = (date) => {
    return date.format('DD MMM. YYYY')
}